export class NotificationInteraction {
    public id: number | null;
    public user_id: number;
    public notification_id: number;
    public notification_type: string;

    constructor(data: NotificationInteractionData | void) {
        if (data === undefined) {
            this.id = null;
            this.user_id = 0;
            this.notification_id = 0;
            this.notification_type = "";
        } else {
            this.id = data.id;
            this.user_id = data.user_id;
            this.notification_id = data.notification_id;
            this.notification_type = data.notification_type;
        }
    }

    serializeData(){
        return  {
            id: this.id,
            user_id: this.user_id,
            notification_id: this.notification_id,
            notification_type: this.notification_type,
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.user_id = 0;
        this.notification_id = 0;
        this.notification_type = "";
    }
}

export type NotificationInteractionData = {
    id: number | null;
    user_id: number;
    notification_id: number;
    notification_type: string;
}
